import { reject } from 'lodash-es';
import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import ConfirmButton from '../confirm-button';
import type { Group } from '../../types/Group';
import type { GroupMember } from '../../types/GroupMember';
import { useAppContext } from '../../contexts/app';
import { removeGroupMemberMutation, groupMembersQuery } from '../../apollo/groups';

type Props = {
  group?: Group;
  member?: GroupMember;
};

const GroupMemberRemoveButton = ({ member, group }: Props) => {
  const { loggedInUser } = useAppContext();
  const [removeGroupMember] = useMutation(removeGroupMemberMutation, {
    update: (proxy, { data: { removeGroupMember: groupMember } }) => {
      const queryVariables = {
        slug: group.slug
      };
      const data = proxy.readQuery({
        query: groupMembersQuery,
        variables: queryVariables
      });
      proxy.writeQuery({
        query: groupMembersQuery,
        variables: queryVariables,
        data: {
          ...data,
          group: {
            ...data.group,
            members: reject(data.group.members, ({ id }) => id === groupMember.id)
          }
        }
      });
    }
  });
  const [submitting, setSubmitting] = useState(false);

  // can't update yourself
  if (!loggedInUser || member.user.id === loggedInUser.id) {
    return null;
  }

  return (
    <ConfirmButton
      variant="outlined"
      onClick={() => {
        setSubmitting(true);
        removeGroupMember({
          variables: {
            id: member.id
          }
        }).then(() => setSubmitting(false));
      }}
      disabled={submitting}
      label="Remove Member"
      confirmMessage={`Are you sure you would like to remove ${member.user.displayName} from this group?`}
      size="small"
    />
  );
};

export default GroupMemberRemoveButton;
